import { get, post, patch, remove } from "../../../../utils/apiUtils";

import type {
  AddToDashboardPayload,
  CriticalMeasurePayload,
  CriticalMeasureResponse,
  DashboardCardResponse,
  ExecuteFormulaResponse,
  FormulaListResponse,
  FormulaPayload,
  FormulaResponse,
  FormulaVariablesResponse,
  FormulaVocabulary,
  ResultViewKey,
  ResultViewsResponse,
  SaveFormulaResponse,
  VerifyFormulaResponse,
} from "./formulaBuilder.types";

export const getFormulaVariables = (projectId: string) => {
  return get<FormulaVariablesResponse>(
    `analyze/projects/${projectId}/formula-builder/variables`,
  );
};

export const getFormulaVocabulary = (projectId: string) => {
  return get<FormulaVocabulary>(
    `analyze/projects/${projectId}/formula-builder/vocabulary`,
  );
};

export const getFormulas = (
  projectId: string,
  params?: { skip?: number; limit?: number },
) => {
  return get<FormulaListResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas`,
    {
      params: {
        skip: params?.skip ?? 0,
        limit: params?.limit ?? 10,
      },
    },
  );
};

export const createFormula = (projectId: string, payload: FormulaPayload) => {
  return post<FormulaResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas`,
    payload,
  );
};

export const getFormula = (projectId: string, formulaId: string) => {
  return get<FormulaResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas/${formulaId}`,
  );
};

export const updateFormula = (
  projectId: string,
  formulaId: string,
  payload: FormulaPayload,
) => {
  return patch<FormulaResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas/${formulaId}`,
    payload,
  );
};

export const deleteFormula = (projectId: string, formulaId: string) => {
  return remove(
    `analyze/projects/${projectId}/formula-builder/formulas/${formulaId}`,
  );
};

export const validateFormula = (projectId: string, formulaId: string) => {
  return post<VerifyFormulaResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas/${formulaId}/validate`,
    {},
  );
};

export const executeFormula = (projectId: string, formulaId: string) => {
  return post<ExecuteFormulaResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas/${formulaId}/execute`,
    {},
  );
};

export const saveFormula = (
  projectId: string,
  formulaId: string,
  params?: { dimension?: string; include_views?: boolean },
) => {
  return post<SaveFormulaResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas/${formulaId}/save-formula`,
    {},
    { params },
  );
};

export const getResultViews = (
  projectId: string,
  formulaId: string,
  params?: { dimension?: string },
) => {
  return get<ResultViewsResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas/${formulaId}/result-views`,
    { params },
  );
};

export const addViewToDashboard = (
  projectId: string,
  formulaId: string,
  view: ResultViewKey,
  payload: AddToDashboardPayload,
) => {
  return post<DashboardCardResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas/${formulaId}/result-views/${view}/add-to-dashboard`,
    payload,
  );
};

export const saveCriticalMeasure = (
  projectId: string,
  formulaId: string,
  payload: CriticalMeasurePayload,
) => {
  return post<CriticalMeasureResponse>(
    `analyze/projects/${projectId}/formula-builder/formulas/${formulaId}/critical-measure`,
    payload,
  );
};
